import React from 'react';
import { Provider } from 'react-redux';
import { ChakraProvider, theme } from '@chakra-ui/react';
import BasePage from './components/base-page';
import './App.scss'
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import LoginPage from './components/login';
import { store, persistStoreObject } from './state/store';

function App() {

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistStoreObject}>
        <ChakraProvider theme={theme}>
          <Router>
            <Routes>
              <Route path={'/'} element={<LoginPage />} key={`Login Page`} />
              <Route path={'*'} element={<BasePage />} key={`Base Page`} />
            </Routes>
          </Router>
        </ChakraProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;
